export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  { width: 40, align: 'center', fixed: 'left', type: 'checkbox' },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 60,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'pickupCityName',
    title: '发货城市',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveCityName',
    title: '收货城市',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totQty',
    title: '总件数',
    headerAlign: 'center',
    align: 'right',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totInWeight',
    title: '总收入重量KG',
    headerAlign: 'center',
    align: 'right',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totInVolume',
    title: '总收入体积m³',
    headerAlign: 'center',
    align: 'right',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totPayWeight',
    title: '总支出重量KG',
    headerAlign: 'center',
    align: 'right',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totPayVolume',
    title: '总支出体积m³',
    headerAlign: 'center',
    align: 'right',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totValue',
    title: '总货值',
    headerAlign: 'center',
    align: 'right',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderCount',
    title: '订单数',
    headerAlign: 'center',
    align: 'right',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
